import PodcastAsset from '../podcast/PodcastAsset'

export default class PodcastsAsset {
  constructor(obj, type) {
    this.podcasts = []

    this.title = obj.title
    this.type = 'podcasts'

    if (type === 'podcastHero') {
      this.type = 'podcastsHero'
    }

    if (obj && obj.items && obj.items.length > 0) {
      obj.items = obj.items.slice(0, 5)
      this.podcasts = obj.items.map(blck => {
        return new PodcastAsset(blck, type)
      })
    }
  }
}
